var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"el",style:({ cursor: 'pointer' }),on:{"click":function($event){return _setup.setClickedAgent(_vm.$props.agent)}}},[_vm._v(" "+_vm._s(_vm.$props.agent)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }